import m from "../../geodata/es2015/armeniaLow";
window.am4geodata_armeniaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/armeniaLow.js
// module id = null
// module chunks = 